import { inject, singleton } from "tsyringe";
import { IListingFixerConfig, ServerSettings } from './settings/server-settings';

@singleton()
export class ListingFixerConfig {
  public readonly settings: IListingFixerConfig;

  constructor(@inject(ServerSettings) serverSettings: ServerSettings) {
    this.settings = serverSettings.settings.listingFixer;
  }
}
